import { get } from 'js/utils/fetch.util';
import { prop, identity } from 'ramda';
import { useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { addTags } from 'js/components/system/App/store/actions';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

import * as helpers from './helpers';

export const useGetOnResponse = () => {
    const dispatch = useDispatch();

    return useCallback((response) => {
        const tags = helpers.parse(response);

        dispatch(addTags(tags));

        return tags;
    }, [dispatch]);
};

export const useGetTags = () => {
    const onResponse = useGetOnResponse();
    const getCMSResourceURL = useGetCMSResourceURL();
    const formFactor = useDeviceSelector(prop('formFactor'));
    const requestStamp = useAppSelector(prop('requestStamp'));
    const [{ isLoading, error, data: tags }, refetch] = useDataFetch({
        fetch: get,
        onResponse,
        initialData: [],
        shouldFetch: identity
    });

    useEffect(() => {
        if (!formFactor) {
            return;
        }

        const resourceURL = getCMSResourceURL(`/initialResources/tags/${formFactor}`, { t: requestStamp });

        refetch(resourceURL);
    }, [refetch, requestStamp, getCMSResourceURL, formFactor]);

    return [{ isLoading, error, tags }, refetch];
};
